/*@flow*/
import getQueryKey from 'lib/getQueryKey';
import skipNulls from 'lib/skipNulls';
import getBbox from 'lib/getBbox';
import * as I from 'immutable';

export default () => {
  let filter = getQueryKey('filter', I.Map());
  return skipNulls(filter.set('bbox', getBbox()));
};
